import { Grid, Grounder } from '@innovamat/glimmer-components';

import { useUser } from '../../../../user-management';

import { Shortcuts, ShortcutsSkeleton } from '../../../../contents';
import { MyClasses, MyClassesSkeleton } from '../../../components/my-classes';

import { LandingPageDistrictAdminSkeleton } from './landing-page-district-admin-skeleton';

import { useState } from 'react';
import { MySchool } from '../../../components/my-school';
import { ColWithMargin, Container } from '../styles';
import { SelectOrganization } from './select-organization';

function LandingPageDistrictAdmin(): JSX.Element {
  const { user } = useUser();

  const [isChangingOrganization, setIsChangingOrganization] = useState(false);

  const showGeneralSkeleton = !user;

  return (
    <>
      {showGeneralSkeleton ? (
        <LandingPageDistrictAdminSkeleton />
      ) : (
        <Container>
          <Grid.Row justifyContent="center">
            <ColWithMargin md={10} lg={8}>
              <MySchool
                isChangingOrganization={isChangingOrganization}
                organizationId={user?.organization?.id!}
                actions={
                  <SelectOrganization
                    onChangeOrganization={() => setIsChangingOrganization(true)}
                  />
                }
              />
            </ColWithMargin>

            <Grid.Col md={10} lg={8}>
              {!isChangingOrganization ? <MyClasses /> : <MyClassesSkeleton />}
            </Grid.Col>
          </Grid.Row>

          <Grid.Row justifyContent="center">
            <Grid.Col md={10} lg={8}>
              {!isChangingOrganization ? <Shortcuts /> : <ShortcutsSkeleton />}
            </Grid.Col>
          </Grid.Row>
          <Grounder />
        </Container>
      )}
    </>
  );
}

export { LandingPageDistrictAdmin };
